import AppLayout from '@/layout/AppLayout.vue';
import { createRouter, createWebHashHistory } from 'vue-router'; // switched to hash mode

const router = createRouter({
    history: createWebHashHistory(), // use hash mode to avoid server rewrite config
    routes: [
        {
            path: '/',
            component: AppLayout,
            children: [
                {
                    path: '',
                    redirect: '/login' // removed extra '/' to avoid double slash
                },
                {
                    path: 'login',
                    component: () => import('@/views/pages/login/login.vue')
                },
                {
                    path: 'forgotpassword',
                    component: () => import('@/views/pages/forgot-password/forgot-password.vue')
                },
                {
                    path: 'chooseparameters',
                    component: () => import('@/views/pages/choose-parameters/choose-parameters-form.vue')
                },
                {
                    path: 'defaultuser',
                    component: () => import('@/views/pages/default-user/default-user-form.vue')
                },
                {
                    path: 'oldchangepassword',
                    component: () => import('@/views/pages/change-password/old-change-password.vue')
                },
                {
                    path: 'changepassword',
                    component: () => import('@/views/pages/change-password/change-password.vue')
                },
            ]
        },
    ]
});

export default router;
